import { render } from "./ProductsReportView.vue?vue&type=template&id=707d4227&scoped=true"
import script from "./ProductsReportView.vue?vue&type=script&lang=js"
export * from "./ProductsReportView.vue?vue&type=script&lang=js"

import "./ProductsReportView.vue?vue&type=style&index=0&id=707d4227&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707d4227"]])

export default __exports__